import { render, staticRenderFns } from "./Term.vue?vue&type=template&id=6c828cde&lang=pug"
import script from "./Term.vue?vue&type=script&setup=true&lang=ts"
export * from "./Term.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Term.vue?vue&type=style&index=0&id=6c828cde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports